import { createAuthClient, createAuthConfig } from '@volee/auth'

import { platformRefreshTokenStore } from './refresh-token-store.ts'

// The app's authentication client (docs/design/frontend-v1.md §5): config and redirects come from
// @volee/config through `createAuthConfig(origin)`, so no pool value is redefined here.

// Where the refresh token lands depends on the platform, and on the web it still depends on
// refresh token rotation being on: see ./refresh-token-store.ts and @volee/auth's README.
export const auth = createAuthClient({
  config: createAuthConfig(window.location.origin),
  refreshTokenStore: platformRefreshTokenStore(),
  // The shared phone (spec #278, #302): a tutore's and a child's account side by side.
  multipleAccounts: true,
})
